const lib = require('../library')
const cartUtils = require('./utils/cartUtils')
const prod = process.env.NODE_ENV === 'production'

export default class OffcanvasCart {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.trigger = document.querySelectorAll(
      '[data-offcanvascart-trigger]',
    )
    this.close = document.querySelectorAll('[data-offcanvascart-close]')
    this.cachedCount = this.el.dataset.items
    this.currentCount = document.querySelector('[data-mini-cart-count]')
    this.openCart = this.el.dataset.openCart ? this.el.dataset.openCart : true
  }

  init() {
    if (lib.isDev) {
      console.log('OffcanvasCart.js loaded')
    }
    this.trigger.forEach((trigger) => {
      trigger.addEventListener('click', this.handleOpen)
    })
    this.close.forEach((trigger) => {
      trigger.addEventListener('click', this.handleClose)
    })
  }

  checkIfCartUpdated() {
    const miniCart = document.querySelector(
      '[data-mini-cart-count]',
    )
    if (typeof miniCart === 'undefined' || !miniCart) {
      cartUtils.cartUpdateContents()
      return true
    }

    this.currentCount = miniCart.innerText
    if (this.cachedCount === this.currentCount) {
      return true
    }
    cartUtils.cartUpdateContents()
  }

  handleOpen = (event) => {
    event.preventDefault()
    this.checkIfCartUpdated()
    cartUtils.cartOpenClose('open')
  }

  handleClose = () => {
    cartUtils.cartOpenClose('close')
  }
}
